


<div class="divHome">
  
  <div class="header-container">
    <h1 >Data Personal por Rango</h1>
    <div class="location-container" *ngIf="location">
      <i-tabler name="map-pin"></i-tabler>
      <h1>{{ getLocation(location) }}</h1>
    </div>
  </div>
  <div>
    <mat-form-field appearance="outline" style="width: 100%;height: 50%;font-size: 14px">
      <input matInput (keyup)="applyFilter($event)" placeholder="Filtrar"/>
    </mat-form-field>
  </div>

  <div *ngIf="loading" class="spinner"  >
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>


  <div *ngIf="!loading" class="mat-elevation-z8 overflow">
    <table mat-table [dataSource]="dataSource">

      <ng-container matColumnDef="tipoServicio" >
        <th mat-header-cell *matHeaderCellDef>TIPO SERVICIO</th>
        <td mat-cell *matCellDef="let element">{{ element.tipoServicio }}</td>
      </ng-container>

      <ng-container matColumnDef="categoriaServicio" >
        <th mat-header-cell *matHeaderCellDef>CATEGORIA SERVICIO</th>
        <td mat-cell *matCellDef="let element">{{ element.categoriaServicio }}</td>
      </ng-container>

      <ng-container matColumnDef="categoriaProducto" >
        <th mat-header-cell *matHeaderCellDef>CATEGORIA PRODUCTO</th>
        <td mat-cell *matCellDef="let element">{{ element.categoriaProducto }}</td>
      </ng-container>

      <ng-container matColumnDef="subCategoriaProducto" >
        <th mat-header-cell *matHeaderCellDef>SUBCATEGORIA PRODUCTO</th>
        <td mat-cell *matCellDef="let element">{{ element.subCategoriaProducto }}</td>
      </ng-container>

      <ng-container matColumnDef="comentario" >
        <th mat-header-cell *matHeaderCellDef>COMENTARIO</th>
        <td mat-cell *matCellDef="let element">{{ element.comentario }}</td>
      </ng-container>

      <ng-container matColumnDef="destino" >
        <th mat-header-cell *matHeaderCellDef>DESTINO</th>
        <td mat-cell *matCellDef="let element">{{ element.destino }}</td>
      </ng-container>


      <ng-container *ngFor="let column of paxColumns; let i = index" matColumnDef="{{ column }}">
        <th mat-header-cell *matHeaderCellDef>PAX {{ i + 1 }}</th>
        <td mat-cell *matCellDef="let element">{{ element.nroPersonasPax[i]?.numPax || '-' }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="HeaderList.concat(paxColumns)"></tr>
      <tr mat-row *matRowDef="let row; columns: HeaderList.concat(paxColumns)"></tr>

    </table>
  </div>
  <div [hidden]="loading">
    <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                   showFirstLastButtons>
    </mat-paginator>
  </div>
</div>

